import { render, staticRenderFns } from "./AssignTenant.vue?vue&type=template&id=554202fd&scoped=true"
import script from "./AssignTenant.vue?vue&type=script&lang=js"
export * from "./AssignTenant.vue?vue&type=script&lang=js"
import style0 from "./AssignTenant.vue?vue&type=style&index=0&id=554202fd&prod&scoped=true&media=screen&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554202fd",
  null
  
)

export default component.exports